/*
 *  公共工具函数
 *  zjhangwenxia
 *  2021.7.20
 */

// 函数节流
export function throttle (fn, interval = 500) {
    let timer = null
    let firstTime = true
    return function (...args) {
        if (firstTime) {
            fn.apply(this, args)
            firstTime = false
            return firstTime
        }
        if (timer) {
            return
        }
        timer = setTimeout(() => {
            clearTimeout(timer)
            timer = null
            fn.apply(this, args)
        }, interval)
    }
}

// 函数防抖
export function debounce (fn, delay = 500) {
    let timer = null
    return function (...args) {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            fn.apply(this, args)
        }, delay)
    }
}

/**
 * 图片懒加载
 */
export function lazyLoad (el) {
    let images = document.querySelectorAll(el);
    for (let i = 0; i < images.length; i++) {
        let image = images[i];
        if (getElementTop(image) <= window.innerHeight + document.documentElement.scrollTop) {
            image.src = image.getAttribute('data-src');
        }
    }
}


/**
 * 返回当前元素所在位置
 * @param element
 * @returns {*|number|number}
 */
function getElementTop (element) {
    let actualTop = element.offsetTop;
    let parent = element.offsetParent;

    while (parent !== null) {
        actualTop += parent.offsetTop;
        parent = parent.offsetParent;
    }

    return actualTop;
}
